import { supabase } from '../supabaseClient'

//Tags
let tagDetailsMapByName = {};
async function getTagsByName() {
    if (Object.keys(tagDetailsMapByName).length == 0) {
        await populateTags();
    }
    return tagDetailsMapByName;
}

let tagDetailsMapById = {};
async function getTagsById(fetchLatestData) {
    if (fetchLatestData || Object.keys(tagDetailsMapById).length == 0) {
        await populateTags();
    }
    return tagDetailsMapById;
}

//Todo: Handle error
async function populateTags() {
    let { data: tag_details, error } = await supabase
        .from('tag_details')
        .select('*')

    
    tagDetailsMapById = {};
    tagDetailsMapByName = {};
    for (let i = 0; i < tag_details.length; i++) {
        let parsedData = JSON.parse(tag_details[i].data);
        parsedData.id = tag_details[i].id;
        tagDetailsMapById[parsedData.id] = parsedData;
        tagDetailsMapByName[parsedData.name] = parsedData;
    }
    return tagDetailsMapById;
}

let dbUtil = { 
    getTagsByName, 
    getTagsById
};

export { dbUtil };